import React from "react";
import { reportBlockError } from "../../frontier/block-error-reporting.esm.js";
class BlockErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error(`[BlockErrorBoundary] Error rendering block "${this.props.blockName}":`, error, errorInfo);
    reportBlockError(this.props.blockName, void 0, error);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
export {
  BlockErrorBoundary as default
};
